import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalaryComponent, SalaryComponentCreate, SalaryComponentFilter } from '../data/salaryComponent';

export function createSalaryComponentService(client: AxiosInstance) {
  return createCrudService<SalaryComponent, SalaryComponentCreate, SalaryComponentFilter>(
    client,
    '/hrm/SalaryComponent',
    'id',
  );
}

export type SalaryComponentService = CrudService<SalaryComponent, SalaryComponentCreate, SalaryComponentFilter>;
